export default function (string) {
    return string
        .replace(/\s+/g, '')
        .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '')
        .toLowerCase();
}
